import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/i18n";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Recipes from "@/components/landing/Recipes";
import Hardware from "@/components/landing/Hardware";
import ValueCards from "@/components/landing/ValueCards";
import Comparison from "@/components/landing/Comparison";
import LeadForm from "@/components/landing/LeadForm";
import Footer from "@/components/landing/Footer";
import CompanyInfo from "@/components/pages/CompanyInfo";
import Kvkk from "@/components/pages/Kvkk";

function Landing() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Recipes />
        <Hardware />
        <ValueCards />
        <Comparison />
        <LeadForm />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen overflow-x-clip bg-[#F8F9FA] text-[#221A3D] antialiased">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/sirket-bilgileri" element={<CompanyInfo />} />
            <Route path="/kisisel-verilerin-korunmasi" element={<Kvkk />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}
